<template>
  <div>
    <section class="filter-sticky-top pt-1 ">
      <section class="container-fluid my-1">
        <div class="download-app" v-if="CinemaList.length > 0">
          <div class="row">
            <div class="col-12 pr-0 align-self-center">
              <div class="d-flex align-slef-center">
                <!-- <img :src=" CinemaList[0].OrganizationLogo" height="40" width="40"> -->
                <div class="mb-2">
                  <strong
                    >
                    {{ CinemaList[0].cinema_name }}</strong
                  >
                  <div class="promo-line small">
                    {{ CinemaList[0].cinema_address }}  {{ CinemaList[0].cinema_location?`, ${CinemaList[0].cinema_location}`:CinemaList[0].cinema_location  }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
    <section class=" ownScreen-color" v-if="loadingData == false">
      <div class="container-fluid mb-4">
        <div class="OwnScreening" v-if="OwnScreening.length > 0">
          <Slick
            ref="movieSlicknew"
            :options="movieSlider"
            @afterChange="handleAfterChange"
          >
            <!--  -->
            <div
              v-for="(singleMovie, singleMovieIndex) in OwnScreening"
              :key="singleMovieIndex"
            >
              <div class="movieSlider-container-top mx-auto text-center">
                <div
                  class="img-container"
                  :class="singleMovieIndex == currentSlideInd ? 'active' : ''"
                >
                  <router-link
                    v-on:click.native="goToRoute(singleMovie, singleMovieIndex)"
                    to
                  >
                    <!-- :to="{ name: 'createScreen', params: { movieId: singleMovie.ID,categoryId: 4 }}" -->
                    <img
                      v-lazy="singleMovie.md_thumbnail_url"
                      alt
                      class="img-fluid mx-auto banner"
                    />
                  </router-link>

                  <div class="img-logo">
                    <router-link
                      v-on:click.native="
                        goToRoute(singleMovie, singleMovieIndex)
                      "
                      to
                    >
                      <!-- :to="{ name: 'createScreen', params: { movieId: singleMovie.ID,categoryId: 4 }}" -->
                      <!-- <img src="@/assets/img/svg/gogo-small-icon.svg" class="img-fluid" /> -->
                    </router-link>
                  </div>
                </div>
                <div class="text-center mx-auto pt-2 pt-md-3 movieSliderInfo">
                  <p class="mb-0 title">{{ singleMovie.movie_title }}</p>
                  <ul class="list-inline mb-0 mInfo">
                    <!-- <li class="list-inline-item">{{ singleMovie.Year }}</li> -->
                    <li class="list-inline-item">|</li>
                    <li class="list-inline-item">{{ singleMovie.rating }}</li>
                  </ul>
                </div>
              </div>
            </div>
          </Slick>
        </div>
        <div v-else-if="loadingData == false" class="row">
          <div class="col-12 text-center" style="color:#8d99af">
            <h5>No Movie Found</h5>
          </div>
        </div>
      </div>
    </section>
    <!-- MOVIE DETAILS DESK BANNER -->

    <section
      class="container-fluid d-md-none"
      :class="checkFilterExist == false ? 'my-2' : ''"
      v-if="!checkFilterExist && content_lang_id>0"

    >
      <div class="d-flex justify-content-center align-items-center">
        <div>
          <hr class="hr-line" />
        </div>
        <div class="filter-new-btn mx-2" @click="showFilterModal">
          <div>Filters</div>
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="sliders-h"
            class="svg-inline--fa fa-sliders-h fa-w-16"
            role="img"
            height="20"
            width="20"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
          >
            <path
              fill="#000"
              d="M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z"
            />
          </svg>
        </div>
        <div>
          <hr class="hr-line" />
        </div>
      </div>
    </section>
    <section
      class="container-fluid d-md-none"
      :class="checkFilterExist ? 'my-3' : ''"
      v-if="content_lang_id>0"
    >
      <div class="filter-tabs" v-if="checkFilterExist">
        <div class="row">
          <div class="col-1">
            <span class="mr-3 ml-2" @click="showFilterModal">
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="sliders-h"
                class="svg-inline--fa fa-sliders-h fa-w-16"
                role="img"
                height="17"
                width="17"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path
                  fill="#000"
                  d="M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z"
                />
              </svg>
            </span>
          </div>
          <div class="col-11">
            <ul class="list-inline filter-list mb-0">
              <span v-for="(data, index2) in showFilter" :key="index2">
                <li
                  class="list-inline-item active mr-2"
                  v-for="(item, index) in data.all_filter"
                  :key="index"
                  v-if="item.isActiveFilter == '1'"
                >
                  <div
                    class="d-flex justify-content-center align-items-center"
                    @click="getFilterVal(data, item, index2, index, '1')"
                  >
                    <div>{{ item.title }}</div>
                    <div class="filter-close">x</div>
                  </div>
                </li>
              </span>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <div v-if="loader == false && content_lang_id>0">
        <section>
      <div class="container-fluid mb-5 mt-3 storylineSection">
        <div class="col-12">
          <div class="row">
            <div class="col-md-10 order-2 order-md-1">
              <p class="sTitle" v-if="screeningDetails.length == 0">
                You are welcome to create your own screening
              </p>
              <p class="sTitle" v-else-if="screeningDetails.length == 1">
                Existing Special Screenings
                <router-link to class="link">
                  (Available in
                  <span>{{ AvailableShowInCinema }}</span> Location)
                </router-link>
              </p>
              <p class="sTitle" v-else-if="screeningDetails.length > 1">
                Existing Special Screenings
                <router-link to class="link">
                  (Available in
                  <span>{{AvailableShowInCinema }}</span> Locations)
                </router-link>
              </p>
            </div>
            <div class="col-md-2 order-1 order-md-2 mb-3 mb-md-0 d-none d-md-block">
              <div class="filter-new-btn ml-auto" @click="showFilterModal">
                <div>Filters</div>
                <div>
                  <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="sliders-h"
                    class="svg-inline--fa fa-sliders-h fa-w-16" role="img" height="20" width="20"
                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path fill="#000"
                      d="M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 px-0 px-md-3">
          <div class="row">
            <div class="col-12 col-md-6 col-xl-4 mb-3" v-for="(singleScreening, screeningIndex) in screeningDetails"
              :key="screeningIndex">
              <div class="h-100 d-flex justify-content-between flex-column createScreenBox">
                <div class="d-flex justify-content-between align-items-center py-3 px-3 px-md-4">
                  <div class="d-flex justify-content-between align-items-center">
                    <p class="mb-0 dtText">{{ singleScreening.day }}</p>
                    <div class="d-flex justify-content-center flex-column pl-1">
                      <p class="mb-0 mText">{{ singleScreening.monthName }}</p>
                      <p class="mb-0 dayText">{{ singleScreening.dayName }}</p>
                    </div>
                  </div>
                  <div>
                    <p class="mb-0 dtText">
                      {{ timeFormat(singleScreening.ss_start_show_time).split(" ")[0] }}
                      <sup class="tfText" v-if="timeFormat(singleScreening.ss_start_show_time).split(' ').length>1">{{ timeFormat(singleScreening.ss_start_show_time).split(' ')[1]}} </sup> 
                    </p>
                  </div>
                </div>

                <div class="d-flex justify-content-between align-items-center pb-3 px-3 px-md-4">
                  <div>
                    <p class="mb-0 tName">{{ singleScreening.cine_name }}</p>
                    <p class="mb-0 tAdd">
                      {{ singleScreening.screen_name }} -
                      {{ singleScreening.lang_name }} ({{
                        singleScreening.mf_name
                      }})
                    </p>
                    <p class="mb-0 tAdd">{{ singleScreening.cine_address }} {{ singleScreening.cine_location?`, ${singleScreening.cine_location}`:`` }}</p>
                  </div>
                  <!-- <div>
                    <router-link
                      @click.native="onClickNext(singleScreening)"
                      v-if="singleScreening.ConfirmedStatus == false"
                      :to="{ name: 'seatLayout', params: { movieId: singleScreening.MovieID, categoryId: CategoryID, cinemaScheduleId: singleScreening.CinemaScheduleID }}"
                    >
                      <img src="@/assets/img/svg/next-red-arrow-icon.svg" class="img-fluid" />
                    </router-link>
                    <router-link
                      @click.native="onClickNext(singleScreening)"
                      v-if="singleScreening.ConfirmedStatus"
                      :to="{ name: 'seatLayout', params: { movieId: singleScreening.MovieID, categoryId: CategoryID, cinemaScheduleId: singleScreening.CinemaScheduleID }}"
                    >
                      <img src="@/assets/img/svg/next-green-arrow-icon.svg" class="img-fluid" />
                    </router-link>

                    <button class="btn btn-danger gogo-cus-btn d-none">Select Screeing</button>
                  </div>-->

                  <!-- @2019-09-03 Added By yogesh to show fully booked show -->
                  <div v-if="singleScreening.showType > 0">
                    <router-link @click.native="onClickNext(singleScreening)"
                      v-if="singleScreening.showType == 2" to>
                      <img src="@/assets/img/svg/next-red-arrow-icon.svg" class="img-fluid" />
                    </router-link>
                    <router-link @click.native="onClickNext(singleScreening)"
                      v-if="singleScreening.showType==1" to>
                      <img src="@/assets/img/svg/next-green-arrow-icon.svg" class="img-fluid" />
                    </router-link>

                    <button class="btn btn-danger gogo-cus-btn d-none">
                      Select Screening
                    </button>
                  </div>

                  <div v-if="singleScreening.showType == 3">
                    <p class="mb-0 confText">Fully Booked</p>
                  </div>
                  <!-- @2019-09-03 Added By yogesh to show fully booked show-->
                </div>

                <div class="progressBarBox pt-3 pb-4 px-3 px-md-4">
                  <div class="d-flex justify-content-between align-content-center pb-1">
                    <p v-if="singleScreening.showType === 2" class="mb-0 confText">
                      NOT CONFIRMED
                    </p>
                    <p v-if="singleScreening.showType==1" class="mb-0 confText">
                      CONFIRMED
                    </p>
                    <!-- <p v-if="singleScreening.ConfirmedStatus === false" class="mb-0 text-dark soldStatus"></p> -->
                    <!-- <p v-if="singleScreening.ConfirmedStatus" class="mb-0 soldStatus"> OUT OF  SEATS SOLD</p> -->
                  </div>
                  <div>
                    <b-progress v-if="singleScreening.showType == 2"
                      :max="parseInt(singleScreening.screen_total_seats)" class="proBar red mb-0">
                      <b-progress-bar :value="singleScreening.booked_seats"></b-progress-bar>
                        <p class="mb-0 reqText m-auto  pr-2">
                          Need {{ parseInt(singleScreening.min_seats-singleScreening.booked_seats) }} Seats for Confirmed
                        </p>
                      <!-- <p :class="singleScreening.ConfirmedStatus ? 'd-none' : ''" class="mb-0 reqText ml-auto pr-2"
                        v-html="singleScreening.ExpiryMsg"></p> -->
                    </b-progress>
                    <b-progress v-if="singleScreening.showType==1" :max="parseInt(singleScreening.screen_total_seats)"
                      class="proBar mb-0">
                      <b-progress-bar :value="parseInt(singleScreening.screen_total_seats)">
                        <p class="mb-0 succ-text">
                          {{ parseInt(singleScreening.screen_total_seats-singleScreening.booked_seats) }} Seats Left
                        </p>
                      </b-progress-bar>
                    </b-progress>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-md-6 col-xl-4 mb-3">
               <router-link :to="{
                  name: 'specialScreening',
                  params: { movieId: MovieID, categoryId: 2 ,content_lang_id:content_lang_id,cinemaId:cinema_id}
                }">
                <div class="h-100 d-flex justify-content-center flex-column createBlankBox">
                  <div class="text-center pb-2">
                    <img src="@/assets/img/svg/add-red-icon.svg" class="img-fluid" />
                  </div>
                  <p class="text-center gogo-dtxt">Create Your Own Screening</p>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>


    <section class="bg-light py-5 py-md-4">
      <div class="container-fluid my-md-4 storylineSection">
        <div class="row">
          <div class="col-md-6 pl-3 pl-xl-5">
            <p class="pb-2 sTitle">Storyline</p>
            <p class="sText">{{ movieDetails.mc_plot }}</p>
          </div>

          <div class="col-md-6">
            <div class="row">
              <div class="col-md-4 text-md-center text-left">
                <p class="pb-2 sTitle">Director</p>

                <ul class="list-inline sList">
                  <li v-for="(director, directorKey) in movieDetails.Directors" :key="directorKey"
                    class="list-inline-item text-center">
                    <img v-lazy="director.mcc_cast_name" class="img-fluid rounded-circle"  style="width:100px;height:100px" />
                    <p class="mb-0 sName">{{ director.mcc_cast_name }}</p>
                  </li>
                </ul>
              </div>

              <div class="col-md-8">
                <p class="pb-2 sTitle">Cast</p>

                <ul class="list-inline sList">
                  <li v-for="(actor, actorKey1) in movieDetails.Actors" :key="actorKey1" class="text-center">
                    <img v-lazy="actor.mcc_cast_name" class="img-fluid rounded-circle"  style="width:100px;height:100px"/>
                    <p class="mb-0 sName">{{ actor.mcc_cast_name }}</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

      <!-- CREATE YOUR OWN SCREENING SLIDER -->
      <section>
        <div class="container-fluid my-4">
          <OwnScreening />
        </div>
      </section>
    </div>
    <div class="col-12 text-center" v-if="loader">
      <img src="@/assets/img/loadMore.gif" class="load-more" />
    </div>

    <!--FILTER MODAL -->
     <b-modal
      hide-header-close
      hide-footer
      ref="filterModalRef"
      id="filterModal"
      title="Choose Any Filter"
      modal-class="welcome-b"
    >
      <button
        type="button"
        @click="hideFilter()"
        aria-label="Close"
        class="close"
      >
        ×
      </button>
      <div class="col-12 loginmodal p-3 p-md-4">
        <div
          class="filter-tabs"
          v-for="(movie, index1) in showFilter"
          :key="index1"
        >
          <p class="border-bottom pb-2">{{ movie.filter_name }}</p>
          <ul class="list-inline">
            <li
              class="list-inline-item"
              v-for="(data, index2) in movie.all_filter"
              :key="index2"
              v-if="data.value"
              @click="getFilterVal(movie, data, index1, index2, '2')"
              :class="data.isActive == '1' ? 'active' : ''"
            >
              {{ data.title }}
            </li>
          </ul>
        </div>
        <div class="row proceed-btn-filter text-center mt-5 mx-auto">
          <div class="col-6 mx-0 mx-auto">
            <button type="button" name id class="btn" @click="resetFilter">
              Reset
            </button>
          </div>
          <div class="col-6 mx-0 mx-auto">
            <button
              type="button"
              name
              id
              class="btn apply-filter"
              @click="applyFilter"
            >
              Apply Filters
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Slick from "vue-slick";
import { makeRequest } from "@/helper/internet.js";
import { TokenService, CountryService } from "@/services/storage.service";

//   import NowShowing from "@/components/partials/nowShowingSlider.vue";
//   import SpecialScreenings from "@/components/partials/SpecialScreeningsSlider.vue";
import OwnScreening from "@/components/partials/OwnScreeningSlider.vue";
import MainServices from "@/services/mainService.js";
//   import UpcomingFestivals from "@/components/partials/UpcomingMiniFestivals.vue";

export default {
  name: "createScreen",
  directives: {
    // 'dragscroll': dragscroll
  },
  components: {
    Slick,
    OwnScreening
  },
  computed: {
    checkFilterExist() {
      let obj = false;
      this.showFilter.map(x => {
        x.all_filter.map(y => {
          if (y.isActiveFilter == "1") {
            obj = true;
          }
        });
      });
      return obj;
    }
  },

  data() {
    return {
      CinemaId: "",
      movieSlider: {
        dots: true,
        infinite: false,
        speed: 300,
        arrows: false,
        slidesToShow: 55,
        slidesToScroll: 4,
        dots: false,
        responsive: [
          {
            breakpoint: 1700,
            settings: {
              slidesToShow: 5.5,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2.5,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2.5,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1
            }
          }
        ]
      },
      showFilter: [],
      dateTimeSlider: {
        dots: false,
        infinite: false,
        speed: 300,
        arrows: false,
        slidesToShow: 9,
        slidesToScroll: 6,
        dots: false,

        responsive: [
          {
            breakpoint: 1900,
            settings: {
              slidesToShow: 7,
              slidesToScroll: 4,
              infinite: true,
              dots: false
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3.1,
              slidesToScroll: 3,
              infinite: true,
              dots: false
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 2
            }
          }
        ]
      },
      movieDetails: {},
      screeningDetails: [],
      days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      loader: true,
      movie_format: [],
      movie_language: [],
      cinema_name: [],
      sub_regions: [],
      show_time: [],
      loadingData: false,
      OwnScreening: [],
      CinemaList: [],
      currentSlideInd: 0,
      CategoryID: "2",
      content_lang_id:0,
      cinema_id:0,
      AvailableShowInCinema:0
    };
  },
  async beforeMount() {
    this.CinemaId = this.$route.params.cinemaId;
    this.cinema_id=this.$route.params.cinemaId;
    this.showLoading();

    this.fetchCinemasList();
    // this.fetchScreeningDetails();
    // this.fetchFilterDetails();
    await this.getNowShowingData();
  },
  // watch: {
  //   $route(to, from) {
  //     this.MovieID = this.$route.params.movieId;
  //     this.fetchMovieDetails();
  //     this.fetchScreeningDetails();
  //   }
  // },
  methods: {
    goToRoute(item, index) {
      this.$refs.movieSlicknew.goTo(index, true);
      this.currentSlideInd = index;
      this.MovieID = item.movie_id;
      this.content_lang_id =item.content_lang_id;
          // alert("csdfsdf1222")
         this.fetchMovieDetails();
            this.showFilter=[]
        
      this.fetchScreeningDetails();

   
    },
    handleAfterChange(event, slick, currentSlide) {
      this.currentSlideInd = currentSlide;
          // alert("csdfsdf22")
      let array = this.OwnScreening[currentSlide];
      this.MovieID = array.movie_id;
        this.content_lang_id =array.content_lang_id;
        this.showFilter=[]
        
      this.fetchScreeningDetails();

      this.fetchMovieDetails();
    },
      fetchMovieDetails: function() {
      let payload = {
        movie_id: this.MovieID,
        content_lang_id: this.content_lang_id,
        category_id: 1,
        cinema_id: this.cinema_id,
        md_for_ondemand: "Y",
        guest_user_id: null,
        cust_id: 1,
        
      };
      MainServices.GetMovieDetails(payload).then(response => {
        const { data } = response;
        if (data.status) {
          console.log("responseMovie", response);
          this.movieDetails = data.Records[0];
          let trailer=data.Records[0].trailer_array.filter(x=>{
            return x.lang_id==1;
          })
          let directors=data.Records[0].castCrewDetails.filter(z=>{
           return  z.crew_title.includes("Director")
          })
          let Actors=data.Records[0].castCrewDetails.filter(z=>{
           return  z.crew_title.includes("Actor")
          })
          console.log(Actors,directors)
         this.movieDetails["Actors"]=[]
         this.movieDetails["Directors"]=[]
         

          if(directors.length>0){
            this.movieDetails["Directors"]=directors[0]["Crew"];
          }
          if(Actors.length>0){
            this.movieDetails["Actors"]=Actors[0]["Crew"];
          }

          if(trailer.length>0){
            this.movieDetails.original_trailer=trailer[0].mt_link
          }
          this.hideLoading();
        }
      }).catch((err) => {
        console.log("error", err);
      })
    },
    fetchCinemasList: function() {
      let payload = {
        cinema_id: this.$route.params.cinemaId
      };
       MainServices.GetCinemaList(payload)
        .then(response => {
          const { error, data } = response;
          this.CinemaList = data.Records;
        })
        .catch(error => {
          console.log("Error", error);
        });
    },
    getNowShowingData: function() {
      this.loadingData = true;
      let payload = {
        CategoryID: 1,
        Version: "1",
        cinema_name: this.$route.params.cinemaId
      };
      if (this.showFilter.length > 0) {
        this.showFilter.map(x => {
          if (this.filterObj[x.filter_key].length > 0) {
            payload[x.filter_key] = this.filterObj[x.filter_key].toString();
          } else {
            delete payload[x.filter_key];
          }
        });
      }
       MainServices.GetTodaysScreening({cinema_id:this.cinema_id})
        .then(response => {
          const { error, data } = response;
          if (data.status) {
            if (data.Records.data.length > 0) {
              this.getCreatShowDataData(data.Records.data);
            } else {
              this.getCreatShowDataData([]);
            }
          } else {                
            this.getCreatShowDataData([]);
          }
        })
        .catch(error => {
          console.log("Error", error);
        });
    },

    getCreatShowDataData: function(array) {
       MainServices.GetCreateOwnShow({cinema_id:this.cinema_id})
        .then(response => {
          const { error, data } = response;
           
            let newArray = array.concat(data.Records.data);
            newArray.map(x=>{
              let findIndexNew=this.OwnScreening.findIndex(y=>{
                return y.movie_id==x.movie_id
              })
              if(findIndexNew<0){
                this.OwnScreening.push(x);

              }
            });
            console.log( this.OwnScreening," this.OwnScreening")
            if (this.OwnScreening.length > 0) {
              this.loadingData = false;

              this.$nextTick(() => {
                this.$refs["movieSlicknew"].destroy();
                this.$refs.movieSlicknew.create();

                this.$refs.movieSlicknew.goTo(0, true);
              });
              this.MovieID = this.OwnScreening[0].movie_id;
              this.content_lang_id = this.OwnScreening[0].content_lang_id;
             
              this.fetchMovieDetails();
              
            } else {
              // this.$refs.movieSlicknew.destroy();
              this.OwnScreening = [];
              this.loader=false
            this.hideLoading();
            }
            this.loadingData = false;
         
            this.hideFilter();
       
        })
        .catch(error => {
          console.log("Error", error);
        });
    },
    // resetFilter: function() {
    //   this.showFilter.map(x => {
    //     this[x.filter_key] = [];
    //   });
    //   this.fetchScreeningDetails();
    //   this.fetchFilterDetails();
    // },
     resetFilter: function() {
      this.showFilter.map(x => {
        this[x.filter_key] = [];
      });

      this.showFilter=[];
      this.fetchScreeningDetails()
     this.hideFilter();
      
      // this.fetchScreeningDetails();
      // this.fetchFilterDetails();
    },
      getFilterVal(movie, data, index1, index2, val) {
        let i = this[movie.filter_key].indexOf(data.value);
          this[movie.filter_key]=[];
          this.showFilter[index1].all_filter.map(y=>{
            y.isActive="0";
            y.isActiveFilter="0"
              })
        if(i >= 0){
          
             if (val == "1") {
              this.fetchScreeningDetails()
             }
           return false

        }
         this.showFilter[index1].all_filter.map(y=>{
            y.isActive="0";
            y.isActiveFilter="0"
              })
    
      setTimeout(x=>{
           
      if (i >= 0) {
        this[movie.filter_key].splice(i, 1);
        this.showFilter[index1].all_filter[index2].isActive = "0";
        if (val == "1") {
          this.showFilter[index1].all_filter[index2].isActiveFilter = "0";
        }
      } else {
        this[movie.filter_key].push(data.value);
        this.showFilter[index1].all_filter[index2].isActive = "1";
      }
      if (val == "1") {
        // this.fetchScreeningDetails();
      }

      },100)
      
  
      // let i = this[movie.filter_key].indexOf(data.value);
      // if (i >= 0) {
      //   this[movie.filter_key].splice(i, 1);
      //   this.showFilter[index1].all_filter[index2].isActive = "0";
      // } else {
      //   this[movie.filter_key].push(data.value);
      //   this.showFilter[index1].all_filter[index2].isActive = "1";
      // }
    },
    showFilterModal() {
      this.$refs["filterModalRef"].show();
    },
    hideFilter() {
      this.$refs["filterModalRef"].hide();
    },
    fetchFilterDetails: function() {
      let payload = {
        CinemaList: false
      };
      makeRequest("/GetShowFilters/", "POST", null, payload)
        .then(response => {
          const { error, res } = response;

          res.data.Filters.map(x => {
            x.all_filter.map(y => {
              y["isActive"] = "0";
              y["isActiveFilter"] = "0";
            });
          });
          this.showFilter = res.data.Filters;
        })
        .catch(error => {
          console.log("Error", error);
        });
    },

     applyFilter() {
      this.showFilter.map(x => {
        x.all_filter.map(y => {
          if (y.isActive == "1") {
            y.isActiveFilter = "1";
          }
        });
      });

      this.fetchScreeningDetails();
      this.hideFilter()
    },
    fetchScreeningDetails: function() {
       let payload = {
        movie_id: this.MovieID,
        cinema_id:this.cinema_id,
      };
    // alert("csdfsdf")
      if (this.showFilter.length > 0) {
        this.showFilter.map(x => {
          if (this[x.query_id].length > 0) {
            payload[x.query_id] = this[x.filter_key].toString();
          }
        });
      }
       MainServices.getMovieConfirmedList(payload).then(response => {
    
          const { error, data } = response;
          this.hideLoading();
          this.loader=false
          if (data.MovieListArrayNew.length > 0){
               this.AvailableShowInCinema =
                data.MovieListArrayNew[0].CinemaList.length;
                  
            if(this.showFilter.length==0){
                data.FilterData.map(x => {
              x.all_filter.map(y => {
                y["isActive"] = "0";
                y["isActiveFilter"] = "0";
               });
               });
                  this.showFilter =data.FilterData;  
            }
           
            }else{
              this.AvailableShowInCinema=0
            }
             
            if (data.Records.data.length > 0) {
              this.screeningDetails = data.Records.data;
            }else{
               this.screeningDetails =[]
            }
        
          this.$refs["filterModalRef"].hide();
        })
        .catch(error => {
          console.log("Error", error);
        });
      function tConvert(time) {
        // Check correct time format and split into components
        time = time
          .toString()
          .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

        if (time.length > 1) {
          // If time format correct
          time = time.slice(1); // Remove full string match value
          time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
          time[0] = +time[0] % 12 || 12; // Adjust hours
        }
        return time.join(""); // return adjusted time or original string
      }
    },
    onClickNext: function(cinemaDetails, CategoryID) {
      let showDetails = {
        CinemaName: cinemaDetails.cine_name,
        CinemaAddress: cinemaDetails.cine_address,
        ShowDateTime:
          cinemaDetails.monthName +
          " " +
          cinemaDetails.day +
          ", " +
          cinemaDetails.Year +
          " | " +
          cinemaDetails.ss_start_show_time
      };
      // let country = CountryService.getCountry();
      this.secureStore.set("STD", showDetails);
      console.log({
          ss_id: cinemaDetails.ss_id,
          screen_id: cinemaDetails.screen_id,
          md_id: cinemaDetails.movie_details_id
        },"cinemaDetails",cinemaDetails)
      this.$router.push({
        name: "seatLayout",
        params: {
          ss_id: cinemaDetails.ss_id,
          screen_id: cinemaDetails.screen_id,
          md_id: cinemaDetails.movie_details_id
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/cinemaCreateScreen.vue